export default __webpack_public_path__ + "65b41f456508278aa44496b53ba1f8d6.svg";